var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandlebar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8C8.67157 8 8 7.32843 8 6.5S8.67157 5 9.5 5s1.5.67157 1.5 1.5S10.32843 8 9.5 8zm0 5c-.82843 0-1.5-.67157-1.5-1.5S8.67157 10 9.5 10s1.5.67157 1.5 1.5-.67157 1.5-1.5 1.5zm0 5c-.82843 0-1.5-.67157-1.5-1.5S8.67157 15 9.5 15s1.5.67157 1.5 1.5-.67157 1.5-1.5 1.5zm5-10c-.82843 0-1.5-.67157-1.5-1.5S13.67157 5 14.5 5s1.5.67157 1.5 1.5S15.32843 8 14.5 8zm0 5c-.82843 0-1.5-.67157-1.5-1.5s.67157-1.5 1.5-1.5 1.5.67157 1.5 1.5-.67157 1.5-1.5 1.5zm0 5c-.82843 0-1.5-.67157-1.5-1.5s.67157-1.5 1.5-1.5 1.5.67157 1.5 1.5-.67157 1.5-1.5 1.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandlebar);
export default __webpack_public_path__ + "static/media/handlebar.3f940ad0.svg";
export { ForwardRef as ReactComponent };